import { errorLogger } from '@/services/unifiedErrorLogger';

export function setupErrorHandlers() {
  window.onerror = (message, source, lineno, colno, error) => {
    console.log('Global error caught:', { message, source, lineno, colno });

    const errorInstance = error || new Error(String(message));
    errorLogger.logError(errorInstance, {
      component: 'global',
      metadata: { source, lineno, colno },
    });
  };

  window.onunhandledrejection = event => {
    console.log('Unhandled rejection caught:', event.reason);

    const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
    errorLogger.logError(error, {
      component: 'global',
      action: 'unhandled_promise_rejection',
    });
  };

  // Sync pending errors on page load
  errorLogger.syncPendingErrors();
}
